import { http } from "~/utils";

export default {
    getNotifications: async (page = 1, filters = {}) => {
        const request_filters = { ...filters, page };
        return http
            .get("/notifications/alerts/", {
                params: request_filters
            })
            .then(response => ({
                list: response.data.results,
                pagination: {
                    actual: response.data.actual,
                    count: response.data.count,
                    next: response.data.next,
                    pages: response.data.pages,
                    previous: response.data.previous
                }
            }));
    },
    updateNotification: async (notification_id, body) => {
        return http.patch(`/notifications/alerts/${notification_id}/`, body).then(response => response.data);
    },
    createNotification: async body => {
        return http.post("/notifications/alerts/", body).then(response => response.data);
    },
    getActiveAlert: async () => {
        return http
            .get("/notifications/alerts/active/")
            .then(response => response.data || null)
            .catch(() => null);
    }
};
